var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpenInSource({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_in_new_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4671",
    "data-name": "Pfad 4671",
    d: "M15,15H4.5V4.5H9.75V3H4.5A1.5,1.5,0,0,0,3,4.5V15a1.5,1.5,0,0,0,1.5,1.5H15A1.5,1.5,0,0,0,16.5,15V9.75H15ZM11.25,3V4.5h2.693L6.57,11.872,7.628,12.93,15,5.557V8.25h1.5V3Z",
    transform: "translate(-0.75 -0.75)",
    fill: "#006b87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenInSource);
export default __webpack_public_path__ + "static/media/Icon_OpenInSource.2fce6b01aacc29b7a8e30c5839dbbc83.svg";
export { ForwardRef as ReactComponent };